import React, { useState } from 'react';
import '../asset/css/Modal.css';
import swal from 'sweetalert';
import { apiPath1, apiPath2 } from "../services/apiConfig";
//import Dashboard from './Dashboard';
import { useNavigate } from 'react-router-dom';
import Dashboard from './Dashboard';

function Modal() {

  const [show, setShow] = useState(true);
  const [oldPw, setOldPw] = useState('')
  const [newPw, setNewPw] = useState('')
  const [cnfPw, setCnfPw] = useState('')
  const userid = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  //const apiPath = "https://cncexam.in/online/api/web/v1/adminpanels/"

  const navigate = useNavigate();

  let txt = "";

  function closeModalHandler() {
    setShow(false);
    ShowPage()
  }

  function ShowPage (){
    navigate('/Dashboard');
      return(<Dashboard />)
  }
  

  async function changePasswpord() {
 //   alert(userid+', '+oldPw+', '+newPw)
    if (newPw !== cnfPw) {
      swal("Please Confirm correct password");
      return
    }
    else {
      let result = await fetch(apiPath1 + "changePassword", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          //        "token":"IG0k6Y1qfvt_dA-4oSzsBNoP_BDqRDUm"
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "user_id": userid,
          "oldpassword": oldPw,
          "newpassword": newPw
        })
      });

      result = await result.json();
      showSwal(result.status, result.msg)
      logout()
    }
  }

  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success !",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }

  function logout(){
    // alert('logout')
    
     localStorage.clear();
     sessionStorage.clear();
     localStorage.removeItem('token');
     localStorage.removeItem('user-info');
     localStorage.removeItem('user-role');
     localStorage.removeItem('user-id');
     localStorage.removeItem('user-id');
     navigate('/');
     window.location.reload();
     
   }

  return (
    <div className="modal__container pwd"
      style={{
        transform: show ? 'translateY(0vh)' : 'translateY(-100vh)',
        opacity: show ? '1' : '0'
      }} >
      <div className="modal-header">
        <h4>Change of Password</h4>
        <span onClick={closeModalHandler} className="mt8"><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></span>
      </div>
      
      <div className="p16">
        <input type="password" className="small"
          placeholder="Old Password" onChange={(e) => setOldPw(e.target.value)} />

        <input type="password" className=" small"
          placeholder="New Password" onChange={(e) => setNewPw(e.target.value)} />

        <input type="password" className=" small"
          placeholder="Confirm Password" onChange={(e) => setCnfPw(e.target.value)} />

        <br /><br />
        <button onClick={changePasswpord} type="button" name="button"
          className="btn gradient round large">Change Password</button>
      </div>
    </div>
  )
};

export default Modal
